import { useTranslation } from "react-i18next";

function InputText({ type, labels, onChange, value, required, style, inputStyle }) {
  const [il8n] = useTranslation();

  return (
    <div
      className="input-box"
      style={inputStyle}
      dir={il8n.language === "en" ? "ltr" : "rtl"}
    >
      <input
        type={type}
        value={value}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        placeholder={labels}
        style={style}

      />
    </div>
  );
}

export default InputText;
